import type { GeocodingService } from './types';
import { MapboxGeocodingService } from './MapboxGeocodingService';

export const geocodingService: GeocodingService = new MapboxGeocodingService();
export type {
  GeocodingService,
  GeocodeResult,
  ReverseGeocodeResult,
} from './types';
